import { FC, PropsWithChildren, ReactNode, memo } from "react";

import { Anchor, Divider, Group } from "@mantine/core";
import { Link } from "react-router-dom";

export type AnchorItemProps = {
  iconLeft: ReactNode;
  iconRight: ReactNode;
  showDivider: boolean;
  useRouterLink: boolean;
  href: string;
};

const AnchorItem: FC<PropsWithChildren<AnchorItemProps>> = ({
  children,
  iconLeft,
  iconRight,
  useRouterLink,
  href,
  showDivider = true,
}) => {
  return (
    <div>
      {useRouterLink ? (
        <Anchor component={Link} to={href} css={{ textDecoration: "none" }}>
          <Group align="center" py={14}>
            {iconLeft}
            <div style={{ flex: "1" }}>{children}</div>
            {iconRight}
          </Group>
        </Anchor>
      ) : (
        <Anchor href={href} target="_blank" css={{ textDecoration: "none" }}>
          <Group align="center" py={14}>
            {iconLeft}
            <div style={{ flex: "1" }}>{children}</div>
            {iconRight}
          </Group>
        </Anchor>
      )}
      {showDivider && <Divider />}
    </div>
  );
};

export default memo(AnchorItem);
